import { ProgressBar } from "@stacklet/ui";

export function LoadingOverlay() {
  return (
    <div className="flex h-full w-full items-end">
      <ProgressBar size="slim" indeterminate />
    </div>
  );
}
